import { dateRangeStyles as styles } from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldDateRange";
import { css } from "styled-components";

styles.datePickersWrapper = {
    ...styles.datePickersWrapper,
    css: css`
        display: flex;
        justify-content: space-between;
        gap: 20px;

        & > div {
            max-width: 48%;
            flex-basis: 48%;
        }
    `,
};

styles.fromDate = {
    ...styles.fromDate,
    cssOverrides: {
        formField: css`
            width: 100%;
            & > div {
                width: 100%;
            }
        `,
    },
};

styles.toDate = {
    ...styles.toDate,
    cssOverrides: {
        formField: css`
            width: 100%;
            & > div {
                width: 100%;
            }
        `,
    },
};
